import { EyeOutlined } from "@ant-design/icons";

import { Card, Table, Tabs } from "antd";
import { LoanForm } from "components";
import { Loader } from "lucide-react";
import React, { Suspense } from "react";
import { Link } from "react-router-dom";
import { useGetLoanApplicationsQuery, useGetUserWalletsQuery } from "store/api";

const LoanApplication = () => {
  const {
    data: loan,
    isLoading,
    refetch,
  } = useGetLoanApplicationsQuery("loan");
  const params = new URLSearchParams(window.location.search);
  const activeTab = params.get("tab");

  const { data: wallets } = useGetUserWalletsQuery("wallets");
  const loans = wallets?.wallets?.find(
    (wallet: any) => wallet?.fields?.type === "loan",
  )?.fields?.amount;

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },

    {
      title: "Requested Date",
      dataIndex: "requestDate",
      key: "requestDate",
      render: (text: any) => new Date(text).toDateString(),
    },
    {
      title: "Loan Type",
      dataIndex: "loanTypeName",
      key: "loanTypeName",
      render: (text: any) => <p className="capitalize">{text}</p>,
    },
    {
      title: "Loan Amount",
      dataIndex: "loanAmount",
      key: "loanAmount",
      render: (text: any) => (
        <p>
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "UGX",
          }).format(text)}
        </p>
      ),
    },
    {
      title: "Loan Term",
      dataIndex: "loanTerm",
      key: "loanTerm",
    },
    {
      title: "Loan Status",
      dataIndex: "loanStatus",
      key: "loanStatus",
      render: (text: any) => {
        return (
          <span
            className={`capitalize ${
              text === "Pending" ? "text-yellow-500" : "text-green-500"
            }`}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Actions",
      render: (text: any) => {
        return (
          <Link to={`/dashboard/loan-request/${text.id}`}>
            <EyeOutlined className="mr-1" />
            View
          </Link>
        );
      },
    },
  ];
  return (
    <Suspense fallback={<Loader className="animate-spin" />}>
      <div className="p-4">
        <Tabs defaultActiveKey={activeTab || "1"}>
          <Tabs.TabPane tab="Loan Applications" key="1">
            <Card title="Loan Applications">
              <Table columns={columns} dataSource={loan} loading={isLoading} />
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab="Apply for Loan"
            key="2"
            disabled={parseFloat(loans) !== 0}
          >
            <Card title="Apply for Loan">
              <LoanForm refetch={refetch} />
            </Card>
          </Tabs.TabPane>
        </Tabs>
      </div>
    </Suspense>
  );
};

export default LoanApplication;
